import { BRAND_STUDIO_ROUTES } from "./brandJourney.mjs";

const categoryRoute = (slug) => `/brand-studio/${slug}`;

export const BRAND_STUDIO_CATEGORIES = [
  {
    id: "logos",
    slug: "logos",
    title: "Логотипы",
    shortDescription: "Основной логотип, компактный знак, монограмма и адаптации фирменного знака.",
    icon: "file-image",
    categoryType: "brand-material",
    route: BRAND_STUDIO_ROUTES.logoWorkshop,
    status: "foundation",
  },
  {
    id: "business-cards",
    slug: "business-cards",
    title: "Визитки",
    shortDescription: "Профессиональные визитки с названием, знаком, контактами и фирменными цветами из Brand Profile.",
    icon: "ticket",
    categoryType: "brand-material",
    route: categoryRoute("business-cards"),
    status: "foundation",
  },
  {
    id: "tags",
    slug: "tags",
    title: "Бирки",
    shortDescription: "Фирменные бирки для коробок, подарков, бенто и других изделий.",
    icon: "bookmark",
    categoryType: "brand-material",
    route: categoryRoute("tags"),
    status: "foundation",
  },
  {
    id: "stickers",
    slug: "stickers",
    title: "Наклейки",
    shortDescription: "Фирменные наклейки разных форм и назначений.",
    icon: "sticker",
    categoryType: "brand-material",
    route: categoryRoute("stickers"),
    status: "foundation",
  },
  {
    id: "ribbons",
    slug: "ribbons",
    title: "Фирменные ленты",
    shortDescription: "Макеты повторяющегося фирменного принта для персонализированных лент.",
    icon: "ribbon",
    categoryType: "brand-material",
    route: categoryRoute("ribbons"),
    status: "foundation",
  },
  {
    id: "storage-serving",
    slug: "storage-serving",
    title: "Хранение и подача",
    shortDescription: "Клиентские рекомендации по хранению и подаче изделия, оформленные в стиле твоего бренда.",
    icon: "refrigerator",
    categoryType: "client-material",
    route: categoryRoute("storage-serving"),
    status: "foundation",
  },
  {
    id: "transportation",
    slug: "transportation",
    title: "Карточки транспортировки",
    shortDescription: "Фирменные инструкции по безопасной перевозке изделия.",
    icon: "truck",
    categoryType: "client-material",
    route: categoryRoute("transportation"),
    status: "foundation",
  },
  {
    id: "cutting",
    slug: "cutting",
    title: "Инструкции по нарезке",
    shortDescription: "Клиентские карточки и схемы по нарезке изделия.",
    icon: "scissors",
    categoryType: "client-material",
    route: categoryRoute("cutting"),
    status: "foundation",
  },
  {
    id: "thank-you",
    slug: "thank-you",
    title: "Благодарственные карточки",
    shortDescription: "Фирменные карточки-вложения с благодарностью, пожеланием или коротким сообщением.",
    icon: "heart",
    categoryType: "client-material",
    route: categoryRoute("thank-you"),
    status: "foundation",
  },
  {
    id: "references",
    slug: "references",
    title: "Референсы",
    shortDescription: "Личная коллекция визуальных материалов для работы с заказами.",
    icon: "layers",
    categoryType: "reference",
    route: categoryRoute("references"),
    status: "foundation",
  },
  {
    id: "client-templates",
    slug: "client-templates",
    title: "Шаблоны для клиента",
    shortDescription: "Повторно используемые фирменные клиентские материалы.",
    icon: "send",
    categoryType: "client-material",
    route: categoryRoute("client-templates"),
    status: "foundation",
  },
  {
    id: "stamps",
    slug: "stamps",
    title: "Штампы",
    shortDescription: "Макеты фирменных штампов и знаков с перспективой точного производственного формата.",
    icon: "stamp",
    categoryType: "brand-material",
    route: categoryRoute("stamps"),
    status: "foundation",
  },
];

export const BRAND_STUDIO_WORKSPACES = [
  {
    id: "materials",
    slug: "materials",
    title: "Мои материалы",
    shortDescription: "Личная библиотека созданных визиток, бирок, наклеек, карточек и других материалов Brand Studio.",
    emptyTitle: "Сохранённых материалов пока нет",
    emptyDescription: "Созданные и сохранённые материалы будут собраны здесь без смешения с рецептами, заметками и Рабочей тетрадью.",
    icon: "file-image",
    categoryType: "workspace",
    route: categoryRoute("materials"),
    status: "foundation",
  },
  {
    id: "templates",
    slug: "templates",
    title: "Шаблоны",
    shortDescription: "Библиотека профессионально подготовленных макетов Anokina Studio.",
    emptyTitle: "Шаблонов пока нет",
    emptyDescription: "Здесь будут собраны профессиональные макеты Anokina Studio, которые используют данные твоего Brand Profile и допускают только контролируемую настройку.",
    icon: "layout",
    categoryType: "workspace",
    route: categoryRoute("templates"),
    status: "foundation",
  },
  {
    id: "attach-to-order",
    slug: "attach-to-order",
    title: "Прикрепить к заказу",
    shortDescription: "Раздел для связи готового материала Brand Studio с конкретным заказом.",
    emptyTitle: "Прикреплённых материалов пока нет",
    emptyDescription: "Здесь можно будет выбрать готовый материал и связать его с нужным заказом без изменения самого заказа.",
    icon: "paperclip",
    categoryType: "workspace",
    route: categoryRoute("attach-to-order"),
    status: "foundation",
  },
];

export const BRAND_STUDIO_ENTRIES = [
  ...BRAND_STUDIO_CATEGORIES,
  ...BRAND_STUDIO_WORKSPACES,
];

export function getBrandStudioEntry(slug) {
  return BRAND_STUDIO_ENTRIES.find((entry) => entry.slug === slug) || null;
}
